/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Refresh_TitleInputs */

const en_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh folders`)
};

const fr_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les dossiers`)
};

const de_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner aktualisieren`)
};

const it_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna cartelle`)
};

const ru_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить папки`)
};

const es_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar carpetas`)
};

const zh_cn2_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新文件夹`)
};

const ja_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを更新`)
};

const hi_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर रीफ़्रेश करें`)
};

const pt_pt2_explorer_nav_refresh_title = /** @type {(inputs: Explorer_Nav_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar pastas`)
};

/**
* | output |
* | --- |
* | "Refresh folders" |
*
* @param {Explorer_Nav_Refresh_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_refresh_title = /** @type {((inputs?: Explorer_Nav_Refresh_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Refresh_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_refresh_title(inputs)
	if (locale === "de") return de_explorer_nav_refresh_title(inputs)
	if (locale === "it") return it_explorer_nav_refresh_title(inputs)
	if (locale === "ru") return ru_explorer_nav_refresh_title(inputs)
	if (locale === "es") return es_explorer_nav_refresh_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_refresh_title(inputs)
	if (locale === "ja") return ja_explorer_nav_refresh_title(inputs)
	if (locale === "hi") return hi_explorer_nav_refresh_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_refresh_title(inputs)
	return en_explorer_nav_refresh_title(inputs)
});